module.exports = __webpack_public_path__ + "img/aiot.7a094d21.png";